export enum SchoolImageVariant {
  Logo = 'LOGO',
}
